export default __webpack_public_path__ + "static/media/login-1.033b00bd.png";